export default "__VITE_ASSET__BN_WpdKP__"